import { render } from "./sharePage.vue?vue&type=template&id=a08c8808&scoped=true"
import script from "./sharePage.vue?vue&type=script&lang=js"
export * from "./sharePage.vue?vue&type=script&lang=js"

import "./sharePage.vue?vue&type=style&index=0&id=a08c8808&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08c8808"]])

export default __exports__